<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} | Road Asset Management Portal</span>
        <span class="flex items-center">
            <span>v{{ $store.state.version }}</span>
            <span style="display:none"><a href="https://www.theletstream.com/">Letstream Ventures Pvt Ltd</a></span>
        </span>
    </footer>
</template>

<script>

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>

<style lang="scss">
    @media screen and (max-width: 768px){
        .the-footer {
            justify-content: center !important;
        }
    }
</style>